import { FormSelectionCardGroupField, lt, useFeatureFlag } from '@mews/framework';
import { Banner } from '@optimus-web/core';
import { groupedRepricingOptions, RepricingFieldName } from './repricingOptions';

export const RepricingGroup = () => {
    const enterpriseProductRepricingEnabled = useFeatureFlag('enterpriseProductRepricingEnabled');

    return enterpriseProductRepricingEnabled ? (
        <FormSelectionCardGroupField
            label={lt('EnterpriseProductEditPricingFormApplyNewPriceLabel')}
            name={RepricingFieldName.RepriceExistingReservations}
            type="radio"
            options={groupedRepricingOptions}
            required
        />
    ) : (
        <Banner variant="info" secondaryText={lt('EnterpriseProductEditPricingFormApplyNewPriceFutureInfoMessage')} />
    );
};
